<template>
  <div>
    <div>
      <!--------- heading and button -------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col md="6" sm="6">
          <h1 class="heading-1 mobile_size_h1">Sales / Orders</h1>
        </v-col>
        <v-col md="6" sm="6" class="pr-0 mt-1">
          <div class="d-flex justify-end">
            <!-- this is commented button for adding payment scenario -->
            <!-- <v-btn
              class="ma-2 pa-4 pl-6"
              color="primary"
              depressed
              @click="PaymentProcessDialog = true"
            >
              Add Payment
            </v-btn> -->
            <v-card flat class="d-flex align-center">
              <router-link to="sales/archived" style="text-decoration: none">
                <v-btn class="ma-2 pa-4" outlined color="#60A6D6">
                  Archived
                </v-btn>
              </router-link>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <!--------- search and filter-------------->
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat style="color: #f2f3f9">
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              single-line
              @input="fetchData"
            ></v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <v-card
            height="45"
            outlined
            class="px-2 mt-n1 d-flex justify-start align-center"
            style="cursor: pointer"
            @click="filterDialog = true"
          >
            <div
              class="d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px"
                  >Filters</span
                >
              </div>

              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
          <!------------------------fliter diloag------------------------------------------>
          <v-dialog v-model="filterDialog" max-width="430" persistent>
            <v-card class="py-5">
              <v-card-title
                class="mb-5 d-flex justify-space-between align-center"
              >
                <div class="text-h5"><b> Filters</b></div>
                <div>
                  <v-btn text depressed class="pa-0" @click="cleanFilter()">
                    <span
                      class="text_style primary--text"
                      style="letter-spacing: 0px"
                      >Clean filters</span
                    >
                  </v-btn>
                  <v-icon class="ml-3" @click="handleCloseFilter()"
                    >mdi-close</v-icon
                  >
                </div>
              </v-card-title>

              <v-card-text>
                <v-select
                  outlined
                  v-model="filterStatus"
                  :items="filterStatusList"
                  dense
                  hide-details
                  label="By Status"
                  persistent-hint
                  :menu-props="{ maxHeight: '400' }"
                ></v-select>
                <!-- :return-value.sync="dateSelected" -->
                <v-menu
                  ref="datarangemenu"
                  v-model="datarangemenu"
                  :close-on-content-click="false"
                  :return-value.sync="Renewaldates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="Renewaldates"
                      label="Order Placed Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      dense
                      class="my-5"
                      hide-details=""
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateSelected"
                    no-title
                    scrollable
                    range
                    :single="true"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datarangemenu = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="handleDatePicked">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <!-- <v-select
                  outlined
                  v-model="filterpaymenttype"
                  :items="filterpaymenttypeList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By Payment Type"
                  multiple
                  persistent-hint
                ></v-select> -->

                <!---------------------Type-modalitiy model filter-------------------------------->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#646464"
                  outlined
                  depressed
                  class="px-5"
                  text
                  @click="handleCloseFilter()"
                >
                  <span class="text_style"> Cancel </span>
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-8 ml-2"
                  @click="fetchData()"
                  depressed
                >
                  <span class="text_style"> Save Filters </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <!--------- data table  -------------->
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :items="GetSales.list"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage()"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ index }">
            <b class="index_index_text">
              {{ index + itemsPerPage * (page - 1) + 1 }}
            </b>
          </template>

          <template v-slot:[`item.OrderCode`]="{ item }">
            <b class="index_index_text"> {{ item.OrderCode }} </b>
          </template>
          <template v-slot:[`item.PaymentType`]="{ item }">
            <b class="index_index_text">
              <span v-if="item?.Items[0]?.PaymentType== 1">Card</span>
              <span v-else-if="item?.Items[0]?.PaymentType== 2">Paypal</span>
              <span v-else-if="item?.Items[0]?.PaymentType== 3">Offline</span>
            </b>
          </template>
          <template v-slot:[`item.Amount`]="{item}">
            <b class="index_index_text">
              <span v-if="item?.Items[0]?.OrderType == 5">{{(item?.Items[0]?.Amount)?.toFixed(2)}}</span> 

              <span v-else-if="item?.Items[0]?.OrderType == 3">
                <span v-if="item?.Items[0]?.SeminarDetail?.MonitorRate && item?.Items[0]?.SeminarDetail?.MonitorDiscount !== 0">
                  {{ (item?.Items[0]?.SeminarDetail?.FullPrice - ((item?.Items[0]?.SeminarDetail?.FullPrice * item?.Items[0]?.SeminarDetail?.MonitorDiscount) / 100))?.toFixed(2) }}
                </span>
                <span v-else>
                  {{ ((isDateEqualOrGreater(item?.Items[0]?.SeminarDetail?.EarlyBirdEndTime) ? item?.Items[0]?.SeminarDetail?.EarlyBirdPrice : item?.Items[0]?.SeminarDetail?.FullPrice) - (item?.Items[0]?.CouponDetail ? ((isDateEqualOrGreater(item?.Items[0]?.SeminarDetail?.EarlyBirdEndTime) ? item?.Items[0]?.SeminarDetail?.EarlyBirdPrice : item?.Items[0]?.SeminarDetail?.FullPrice) * ((parseFloat(item?.Items[0]?.CouponDetail?.DiscountValue) / 100))) : 0))?.toFixed(2) }}
                </span>
               <!-- {{ ((item?.Items[0].Amount) - (item?.Items[0].Amount * ((parseFloat(item?.Items[0]?.CouponDetail?.DiscountValue) / 100) || 0))).toFixed(2) }} -->
              </span>
              <span v-else-if="item?.Items[0]?.OrderType == 1">
                {{(item?.Items[0]?.MemberShipDetail?.Amount)?.toFixed(2)}}
              </span>
              
              <span v-else>
                {{
                  item?.Items[0]?.Product?.CategoryId === 26
                    ? item?.Items[0]?.Payment?.Price?.toFixed(2) 
                    : (
                        Number(calculateTableTotalDiscount(item.Items).totalAmountWithDiscount) +
                        shippingPriceStoreTable(item) +
                        calculateTaxStoreTable(item) -
                        calculateTableTotalDiscount(item.Items).couponDiscount
                      )?.toFixed(2)
                }}
              </span>
            </b>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            <div>
              <v-chip
                v-if="item.Status"
                  class="px-10"
                  text-color="#06A23B"
                  style="background: rgba(227, 243, 233, 1)"
                >
                  {{ item.Status }}
              </v-chip>
            </div>
          </template>
          <!-- <span class="index_head_text"> {{ item.status}} </span> -->
          <!-- <template v-slot:[`item.TrackingId`]="{ item }">
            <div class="pt-8">
              <v-text-field
              v-if="item.TrackingId"
                v-model="item.TrackingId"
                dense
                readonly
                outlined
              ></v-text-field>
            </div>
          </template> -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    @click="openSaleOrder(item.OrderCode)"
                  >
                    <v-icon color="#646464">mdi-eye</v-icon>
                    <span class="ml-4 text_style">See More details </span>
                  </v-btn>
                </v-list>
                <!-- <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="invoiceDialogue = true"
                  >
                    <v-icon color="#646464"> mdi-clipboard-text </v-icon>
                    <span class="ml-4 text_style">Invoice</span>
                  </v-btn>
                </v-list> -->
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="ChangeStatus(item.OrderCode, item.Items[0].Status,item.Items)"
                  >
                    <v-icon color="#646464">mdi-label</v-icon>
                    <span class="ml-4 text_style"> Change Status</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="setArchiveDialogue(item.OrderCode)"
                  >
                    <v-icon color="#646464"> mdi-archive </v-icon>
                    <span class="ml-4 text_style">Archive</span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="setItemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="fetchOrderData"
        ></v-pagination
      ></v-card>
      <v-dialog
        v-model="invoiceDialogue"
        max-width="576"
        @click:outside="closeDialog"
      >
        <v-card>
          <div class="mx-5 py-5 d-flex justify-space-between">
            <span class="heading-2">Invoice Empty</span>
            <v-icon @click="invoiceDialogue = false">mdi-close</v-icon>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="archieveDialogue"
        max-width="576"
        @click:outside="closeDialog"
      >
        <v-card>
          <div class="mx-5 py-5 d-flex justify-space-between">
            <span class="heading-2"></span>
            <v-icon @click="archieveDialogue = false">mdi-close</v-icon>
          </div>
          <div class="pa-5 text-center font-weight-bold">
            <span class="text-h6"
              >Are you sure you want to set this order to archive?</span
            >
          </div>
          <div class="d-flex justify-center gap-3 pb-10">
            <div>
              <v-btn color="primary" class="px-9" :disabled="btnloader" @click="archieveStatus()">
                <span v-if="btnloader != true">Yes</span>
                <v-progress-circular
                  indeterminate
                  v-else
                  size="20"
                  class="px-5"
                  color="white"
                  v-show="btnloader"
                ></v-progress-circular>
              </v-btn>
            </div>
            <v-btn
              color="primary"
              class="px-9"
              outlined
              @click="archieveDialogue = false"
            >
              No
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editdialog" persistent max-width="520">
        <v-card>
          <div class="mx-5 py-5 d-flex justify-space-between">
            <span class="heading-2"></span>
            <v-icon @click="editdialog = false">mdi-close</v-icon>
          </div>
          <div class="pa-5">
            <div class="pb-3"><b>Set Status</b></div>
            <v-select
              outlined
              v-model="Status"
              :items="filterStatusList"
              dense
              hide-details
              label="Status"
              persistent-hint
              :menu-props="{ maxHeight: '400' }"
            ></v-select>
          </div>
          <div class="d-flex justify-end mx-5 py-5">
            <v-btn color="#A1A3A8" text @click="editdialog = false">
              Cancel
            </v-btn>
            <v-btn color="primary" class="px-9" @click="SaveStatus">
              Save
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog max-width="900" v-model="PaymentProcessDialog" persistent>
        <v-card class="px-6 pt-8 pb-4">
          <UserPaymentComponent
            :PaymentProcess="PaymentProcessDialog"
            @close="close"
          ></UserPaymentComponent>
        </v-card>
      </v-dialog>
    </div>
    <div></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserPaymentComponent from "../../components/Sales/salespayemnt.vue";
// import moment from "moment";
import axios from "axios";
export default {
  components: {
    UserPaymentComponent,
  },
  data() {
    return {
      items: null,
      btnloader: false,
      selectedDate: null,
      filterStatus: "",
      filterStatusList: ["NEW", "RECEIVED", "SHIPPED", "INVOICED", "VOID"],
      filterStore: [],
      filterStoreList: ["CBP", "CBP-A", "CBI", "MSI"],
      filterpaymenttype: [],
      filterpaymenttypeList: ["STRIPE", "PAYPAL", "CREDIT CARD", "CHEQUE"],

      filterDialog: false,
      datarangemenu: false,
      dateSelected: [],
      dateRangeText: "",
      PaymentProcessDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10 || "",
      Permission: {},
      infodialog: false,
      SeeProfileDialog: false,
      previewDialog: false,
      editdialog: false,
      Status: "New",
      archieveDialogue: false,
      invoiceDialogue: false,
      selectedOrderCode: null,
      tableLoader: false, // data-table true or false
      search: "",
      filter: "",
      filterItem: [
        {
          text: "Status (New, Received, Shipped, Invoiced, Void )",
        },
        {
          text: "Store (country)",
        },
        {
          text: "Payment Type",
        },
        {
          text: "Date Range",
        },

        // {
        //   text: "Payment Status (CC, Check, PayP, VISA)",
        // },
      ],
      headers: [
        { text: "#", value: "index" },
        { text: "Order No", value: "OrderCode" },
        { text: "Date Placed", value: "isOrderDate" },
        { text: "Client", value: "UserName" },
        { text: "Payment Type", value: "PaymentType" },
        { text: "Amount", value: "Amount" },
        { text: "Status", value: "Status" },
        // { text: "Tracking #", value: "TrackingId" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
      EditOrderCode: "",
      orderItems: []
    };
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions", "GetSales"]),
    Renewaldates() {
      return this.dateSelected.join(" to ");
    },
  },

  mounted() {
    // Listen for page reload event to clear the search data from localStorage
    window.addEventListener('beforeunload', this.clearSearchQuery);

    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Sales"
    );
    this.tableLoader = true;
    const savedSearch = JSON.parse(localStorage.getItem("orderSearchQuery"));
    if (savedSearch?.status || savedSearch?.date) {
        this.filterStatus = savedSearch?.status;
        this.dateSelected = savedSearch?.date;
        this.search = savedSearch?.query || "";
        this.fetchData();
        this.$store.dispatch("GetProductCategories");
      } else {
        this.$store.dispatch("GetAllOrder").then(() => {
          this.tableLoader = false;
          if (this.itemsPerPage !== "All") {
              const totalRecords = this.GetSales.Total;
              this.pageCount = Math.ceil(totalRecords / this.itemsPerPage);
            } else {
              this.pageCount = 1;
            }
            this.$store.dispatch("GetProductCategories");
        });
      }
  },
  
  beforeDestroy() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('beforeunload', this.clearSearchQuery);
  },

  methods: {
    isDateEqualOrGreater(inputDateStr) {
      const inputDate = new Date(inputDateStr);
      const currentDate = new Date();

      // Check if the input date is today or a future date
      if (inputDate.getFullYear() > currentDate.getFullYear()) {
        return true;
      } else if (inputDate.getFullYear() === currentDate.getFullYear()) {
        if (inputDate.getMonth() > currentDate.getMonth()) {
          return true;
        } else if (inputDate.getMonth() === currentDate.getMonth()) {
          if (inputDate.getDate() >= currentDate.getDate()) {
            return true;
          }
        }
      }
      return false;
    },
    calculateTaxStoreTable(item) {
      if (
        item &&
        item?.Items[0]?.Shipping?.Country?.toLowerCase() === "united states" &&
        item?.Items[0]?.Shipping?.Province?.toLowerCase() === "fl"
      ) {
        const totalAmountWithDiscount = this.calculateTotalDiscount(item?.Items).totalAmountWithDiscount;

        const hasPhysicalProduct = item?.Items?.some((nestedItem) => nestedItem?.Product?.IsPhysical);

        if (hasPhysicalProduct) {
          return totalAmountWithDiscount * 0.07;
        }
      }
      return 0;
    },
    shippingPriceStoreTable(item) {
      let str = item?.Items[0]?.Shipping?.ShippingMethod;
      let match = str?.match(/\(([^)]+)\)/);
      if (match) {
        let number = parseFloat(match[1]);
        return number;
      }
      return 0;
    },
    calculateTableTotalDiscount(items) {
      if (Array.isArray(items) && items.length > 0) {
        // Calculate the total discounted amount and total amount for all items
        const { totalDiscount, totalAmount } = items.reduce(
          (acc, item) => {
            // Inside the reduce function, calculate the total and discounted amount for each item
            const { discountedAmount, amount } =
              this.calculateAmountAndDiscount(item);

            // Add the discounted amount to the total discount
            acc.totalDiscount += parseFloat(discountedAmount);
            // Add the total amount to the total amount
            acc.totalAmount += parseFloat(amount);

            return acc;
          },
          { totalDiscount: 0, totalAmount: 0 }
        );

        // Calculate the total discount applied to the total amount
        const totalDiscountApplied = totalAmount - totalDiscount;
        const couponDiscount = items[0]?.CouponDetail?.DiscountValue
          ? totalAmount * (parseFloat(items[0]?.CouponDetail?.DiscountValue) / 100)
          : 0;
        // Return an object containing the required values
        return {
          totalAmount: totalAmount?.toFixed(2),
          couponDiscount: couponDiscount?.toFixed(2),
          totalDiscountApplied: totalDiscountApplied?.toFixed(2),
          totalAmountWithDiscount: totalDiscount?.toFixed(2),
        };
      } else {
        // Return an object with default values if the array is empty or invalid
        return {
          totalAmount: 0.00,
          totalDiscountApplied: 0.00,
          totalAmountWithDiscount: 0.00,
          couponDiscount: 0.00,
        };
      }
    },
    calculateTotalDiscount(items) {
      if (Array.isArray(items) && items.length > 0) {
        // Calculate the total discounted amount and total amount for all items
        const { totalDiscount, totalAmount } = items.reduce(
          (acc, item) => {
            // Inside the reduce function, calculate the total and discounted amount for each item
            const { discountedAmount, amount } =
              this.calculateAmountAndDiscount(item);

            // Add the discounted amount to the total discount
            acc.totalDiscount += parseFloat(discountedAmount);
            // Add the total amount to the total amount
            acc.totalAmount += parseFloat(amount);

            return acc;
          },
          { totalDiscount: 0, totalAmount: 0 }
        );

        // Calculate the total discount applied to the total amount
        const totalDiscountApplied = totalAmount - totalDiscount;
        const couponDiscount = this.GetSales?.list?.Items?.[0]?.CouponDetail?.DiscountValue
          ? totalAmount * (parseFloat(this.GetSales?.list?.Items?.[0]?.CouponDetail?.DiscountValue) / 100)
          : 0;
        // Return an object containing the required values
        return {
          totalAmount: totalAmount?.toFixed(2),
          couponDiscount: couponDiscount?.toFixed(2),
          totalDiscountApplied: totalDiscountApplied?.toFixed(2),
          totalAmountWithDiscount: totalDiscount?.toFixed(2),
        };
      } else {
        // Return an object with default values if the array is empty or invalid
        return {
          totalAmount: 0.00,
          totalDiscountApplied: 0.00,
          totalAmountWithDiscount: 0.00,
          couponDiscount: 0.00,
        };
      }
    },
    calculateAmountAndDiscount(item) {
      // Calculate the discounted amount for a single item
      const discountedAmount = (
        (1 - item.Product?.DiscountPercentage / 100) * // Discount factor
        item.Amount *
        item.Quantity
      )?.toFixed(2);

      // Calculate the total amount for a single item
      const amount = (item.Amount * item.Quantity)?.toFixed(2);

      // Return an object containing both the total amount and discounted amount
      return { amount, discountedAmount };
    },
    ChangeStatus(orderCode, status,items) {
      this.items = items
      this.EditOrderCode = orderCode;
      if (status === 2) {
        this.Status = "NEW";
      } else if (status === 3) {
        this.Status = "RECEIVED";
      } else if (status === 4) {
        this.Status = "SHIPPED";
      } else if (status === 5) {
        this.Status = "INVOICED";
      } else {
        this.Status = "VOID";
      }

      this.editdialog = true;
    },
    SaveStatus() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      let hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      const formattedDateTime = `${formattedDate}T${hours}:${minutes}:${seconds}`;

      var obj = {
        orderCode: this.EditOrderCode,
      };
      if (this.Status.toLowerCase() === "new") {
        obj.status = 2;
      } else if (this.Status.toLowerCase() === "received") {
        obj.status = 3;
      } else if (this.Status.toLowerCase() === "shipped") {
        obj.status = 4;
      } else if (this.Status.toLowerCase() === "invoiced") {
        obj.status = 5;
      } else {
        obj.status = 6;
      }
      var data = {
        id: this.items[0]?.Shipping?.Id,
        status: obj.status,
        dateTime: formattedDateTime,
      };
      this.$store.dispatch("ChangeOrderStatus", obj).then((res) => {
        if (res.Status) {
          this.getOrderByOrderCode(this.items)
          this.$store.dispatch("GetAllOrder");
        }
      });
      if (obj.status == 3 || obj.status == 4) {
        this.$store
          .dispatch("UpdateOrderShipAndReceivedDate", data)
      }
      this.editdialog = false;
    },
    getOrderByOrderCode(items) {
      const myHeaders = {
        "Host": "ssapi.shipstation.com",
        "Authorization": "Basic NmQ2M2YyNmY2ZTgwNGIwZjkxOTY2YTE5M2IyYTQzMTc6NzY3ODMwODM0YzljNGMzOTkwYzFiMWViNzVkNTk1Yzk=",
        "Content-Type": "application/json"
      };

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        url: `https://ssapi.shipstation.com/orders?orderNumber=${this.EditOrderCode}`
      };

      axios(requestOptions)
        .then(response => {
          console.log(response.data.orders)
          this.updateOrderForShipstation(response.data.orders[0],items)
        })
        .catch(() => {
        })
    },
    getDate(){
      const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        let hours = currentDate.getHours();
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        const seconds = String(currentDate.getSeconds()).padStart(2, '0');

        hours = hours % 12;
        hours = hours || 12;

        return `${year}-${month}-${day}T${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;
    },
    updateOrderForShipstation(data,items){
      const myHeaders = {
        "Host": "ssapi.shipstation.com",
        "Authorization": "Basic NmQ2M2YyNmY2ZTgwNGIwZjkxOTY2YTE5M2IyYTQzMTc6NzY3ODMwODM0YzljNGMzOTkwYzFiMWViNzVkNTk1Yzk=",
        "Content-Type": "application/json"
      };
      items.forEach((item)=>{
        const obj = {
          sku: item.Product.SKU,
            name: item.Product.ProductName,
            imageUrl: item.Product.CoverImage,
            weight: {
                value: item.Product.Weight,
                units: "ounces"
            },
            quantity: item.Quantity,
            unitPrice: item.Product?.PublicPrice,
            productId: item.ProductId,
        }
        if(item.Product.IsPhysical){
          this.orderItems.push(obj)
        }
      })
        const raw = JSON.stringify({
          "orderNumber": data.orderNumber,
          "orderKey": data.orderKey,
          "orderDate": this.getDate(),
          "paymentDate": this.getDate(),
          "amountPaid": data.amountPaid,
          "taxAmount": data.taxAmount,
          "shippingAmount": data.shippingAmount,
          "paymentMethod": "Credit Card",
          "orderStatus": "shipped",
          "customerUsername": data.customerUsername,
          "customerEmail": data.customerEmail,
        "shipTo": {
          "name": data.shipTo.name,
          "street1": data.shipTo.street1,
          "city": data.shipTo.city,
          "state": data.shipTo.state,
          "postalCode": data.shipTo.postalCode,
          "country": data.shipTo.country,
          "phone": data.shipTo.phone,
          "residential": true
    },
        "billTo": {
        "name": data.billTo.name,
          "street1": data.billTo.street1,
          "city": data.billTo.city,
          "state": data.billTo.state,
          "postalCode": data.billTo.postalCode,
          "country": data.billTo.country,
          "phone": data.billTo.phone,
          "residential": true
    },
    "items": this.orderItems
      });
      if(this.orderItems.length > 0){
        const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data: raw,
        url: "https://ssapi.shipstation.com/orders/createorder"
      };

      axios(requestOptions)
        .then(response => {
          console.log("response ",response)
        })
        .catch((error) => {
          console.log("error ",error)
        })
      }
    },
    close() {
      this.PaymentProcessDialog = false;
    },
    goBack() {
      this.isHidden = false;
    },
    closeDialog() {
      this.add_dialog = false;
      this.value = false;
    },
    openSaleOrder(OrderCode) {
      this.$router.push({
        path: "/sales/salesorder",
        query: { ordernumber: OrderCode },
      });
    },
    setArchiveDialogue(orderCode) {
      this.selectedOrderCode = orderCode;
      this.archieveDialogue = true;
    },

    archieveStatus() {
      this.btnloader = true;
      let ordercode = this.selectedOrderCode;

      if (!ordercode) {
        console.error("No OrderCode Found");
        return;
      }

      this.$store
        .dispatch("ChnageArchieveStatus", { ordercode })
        .then((archieveResponse) => {
          if (archieveResponse.Status) {
            return this.$store.dispatch("GetAllOrder");
          }
        })
        .then(() => {
          this.archieveDialogue = false;
          this.btnloader = false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Archieved Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    displayedItemsPerPage() {
      if (this.itemsPerPage === "All") {
        return this.GetSales.length;
      } else {
        return this.itemsPerPage;
      }
    },
    fetchOrderData() {
      this.tableLoader = true;
      this.search = "";
        let pageNumber = this.page;
        this.$store.dispatch("GetAllOrder", { pageNumber }).then(() => {
          this.tableLoader = false;
        });
    },
    async setItemsPerPage(e) {
      this.tableLoader = true;
      this.search = "";
      if (e === "All") {
        let pageNumber = -1;
        let pageSize = 10000;
        await this.$store
          .dispatch("GetAllOrder", { pageNumber, pageSize })
          .then(() => {
            this.tableLoader = false;
          });
      } else {
        this.page = 1
        let pageSize = parseInt(e);
        await this.$store.dispatch("GetAllOrder", { pageSize }).then(() => {
          this.tableLoader = false;
        });
      }
      //  2024-01-16
      this.calculatePageCount();
    },
    calculatePageCount() {
      if (this.itemsPerPage === "All") {
        this.pageCount = 1;
      } else {
        const totalRecords = this.GetSales.Total;
          this.pageCount = Math.ceil(totalRecords / this.itemsPerPage);
      }
    },
    handleDatePicked() {
      this.$refs.datarangemenu.save(this.dateSelected);
      this.handleSelectedDate();
      this.datarangemenu = false;
    },
    handleSelectedDate() {
      // Get the date part of dateSelected
      let filterDate = this.dateSelected.substring(0, 10);
      console.log("Filter Date:", filterDate);

      // Variable to store the matching OrderDate
      let matchingOrderDate = "";

      this.GetSales.list.forEach((order) => {
        order.Items.forEach((item) => {
          let itemDate = item.OrderDate.substring(0, 10); // Get the date part of OrderDate

          if (itemDate === filterDate) {
            matchingOrderDate = item.OrderDate;

            // Break out of the loop since we found a match
            return;
          }
        });

        // Check if a match was found and break out of the outer loop
        if (matchingOrderDate) {
          return;
        }
      });

      // Now matchingOrderDate contains the complete OrderDate from the matching object
      this.dateSelected = matchingOrderDate;
      // this.fetchData();
    },
    handleCloseFilter() {
      this.filterDialog = false;
      // this.cleanFilter();
    },
    cleanFilter() {
      this.filterStatus = [];
      this.dateSelected = [];
    },
    clearSearchQuery(){
      localStorage.removeItem('orderSearchQuery');
    },
    fetchData() {
      this.tableLoader = true;
      this.filterDialog = false;
      const status =
        this.filterStatus === "NEW"
          ? 2
          : this.filterStatus === "RECEIVED"
          ? 3
          : this.filterStatus === "SHIPPED"
          ? 4
          : this.filterStatus === "INVOICED"
          ? 5
          : this.filterStatus === "VOID" 
          ? 6 
          : "";
      const payload = {
        pageSize: this.itemsPerPage,
        OrderCode: this.search,
        date: this.dateSelected,
        status: status,
      };
      this.$store.dispatch("GetAllOrder", payload).then(() => {
        this.tableLoader = false;
        if (this.itemsPerPage !== "All") {
              const totalRecords = this.GetSales.Total;
              this.pageCount = Math.ceil(totalRecords / this.itemsPerPage);
            } else {
              this.pageCount = 1;
            }
        localStorage.setItem('orderSearchQuery', JSON.stringify({status: this.filterStatus, date: this.dateSelected, query: this.search}));
      });
    },
  },
};
</script>
<style scoped>
.index_index_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;

  color: #222222;
}
.index_head_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.index-heading-1 {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;

  color: rgba(8, 8, 22, 0.87);
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
@media screen and (max-width: 430px) {
  .mobile_size_h1 {
    font-size: 6vw;
  }
}
.v-text-field__details {
  padding-top: 0px;
  margin-bottom: 0px;
}
</style>
